/// <reference types="./managementGetSyncEvents.d.ts" />
import { EventType, notOk, } from '@dossierhq/core';
import { SYNC_EVENTS_LIMIT_MAX } from '../config/Limits.js';
export async function managementGetSyncEvents(databaseAdapter, context, query) {
    const { after, limit } = query;
    if (after !== null && typeof after !== 'string') {
        return notOk.BadRequest('Must specify "after" in query');
    }
    if (typeof limit !== 'number') {
        return notOk.BadRequest('Must specify "limit" in query');
    }
    if (limit < 1 || limit > SYNC_EVENTS_LIMIT_MAX) {
        return notOk.BadRequest(`"limit" must be between 1 and ${SYNC_EVENTS_LIMIT_MAX}`);
    }
    const result = await databaseAdapter.managementSyncGetEvents(context, query);
    if (result.isError())
        return result;
    // Normalize events
    for (const event of result.value.events) {
        if (event.type === EventType.publishEntities || event.type === EventType.unpublishEntities) {
            event.entities.sort((a, b) => a.id.localeCompare(b.id));
        }
    }
    return result;
}
//# sourceMappingURL=managementGetSyncEvents.js.map